export default __webpack_public_path__ + "static/media/logo-footer.8c9df58e.png";